import { Component, computed, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PERMISSIONS } from '../../../../../Enums/permission.enum';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from '../../../../Shared/Services/auth.service';
import { LogoutService } from '../../../../Shared/Services/logout.service';
import { AvThemeToggleComponent } from '../../../../Shared/Components/theme-toggle/theme-toggle.component';
import { NavItem } from '../../../Interfaces/nav-item.interface';

@Component({
  selector: 'app-navigation-menu',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, TranslateModule, AvThemeToggleComponent],
  templateUrl: './navigation-menu.component.html',
  styleUrls: ['./navigation-menu.component.scss'],
})
export class NavigationMenuComponent {
  private readonly _logoutService = inject(LogoutService);
  private readonly _authService = inject(AuthService);
  private readonly _currentUser = toSignal(this._authService.currentUser$, { initialValue: null });

  private readonly _allNavItems: NavItem[] = [
    { id: 'users', labelKey: 'shared.routes.app.settings_users', route: '/settings/users', permission: PERMISSIONS.USER_READ },
    { id: 'roles', labelKey: 'shared.routes.app.settings_roles', route: '/settings/roles', permission: PERMISSIONS.ROLE_READ, entitlement: 'rbac' },
    { id: 'billing', labelKey: 'shared.routes.app.settings_billing', route: '/settings/billing', permission: PERMISSIONS.BILLING_MANAGE },
    { id: 'licences', labelKey: 'shared.routes.app.settings_licences', route: '/settings/licences', permission: PERMISSIONS.LICENSE_MANAGE },
  ];

  readonly navItems = computed(() =>
    this._allNavItems.filter(item =>
      (!item.permission || (this._currentUser()?.hasPermission(item.permission) ?? false)) &&
      (!item.entitlement || (this._currentUser()?.hasEntitlement(item.entitlement) ?? false))
    )
  );

  logout(): void {
    this._logoutService.confirmLogout();
  }
}